"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCampaignModel = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const campaign_creator_info_model_1 = require("../../../../common/models/campaign-creator-info.model");
const discount_campaign_type_enum_1 = require("../types/discount-campaign-type.enum");
const discount_reusability_enum_1 = require("../types/discount-reusability.enum");
const discount_on_stops_1 = require("./discount-on-stops");
class DiscountCampaignModel {
    constructor() {
        this._id = (0, uuid_1.v4)();
        this.type = discount_campaign_type_enum_1.DiscountCampaignType.Regular;
    }
}
exports.DiscountCampaignModel = DiscountCampaignModel;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], DiscountCampaignModel.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], DiscountCampaignModel.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], DiscountCampaignModel.prototype, "createdBy", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => campaign_creator_info_model_1.CampaignCreatorInfoModel),
    __metadata("design:type", campaign_creator_info_model_1.CampaignCreatorInfoModel)
], DiscountCampaignModel.prototype, "createdByInfo", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], DiscountCampaignModel.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DiscountCampaignModel.prototype, "discountCoefficient", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DiscountCampaignModel.prototype, "discountAmount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    __metadata("design:type", Number)
], DiscountCampaignModel.prototype, "discountAmountCurrency", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DiscountCampaignModel.prototype, "minOrderPrice", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DiscountCampaignModel.prototype, "allowedNumberOfUsages", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], DiscountCampaignModel.prototype, "validFrom", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], DiscountCampaignModel.prototype, "validTo", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], DiscountCampaignModel.prototype, "validPaymentMethods", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateIf)((cardTypes) => cardTypes.length > 0),
    __metadata("design:type", Array)
], DiscountCampaignModel.prototype, "validCreditCardTypes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], DiscountCampaignModel.prototype, "reusability", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DiscountCampaignModel.prototype, "usersCanGenerateDiscountCodes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], DiscountCampaignModel.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", discount_on_stops_1.DiscountOnStops)
], DiscountCampaignModel.prototype, "discountOnStops", void 0);
//# sourceMappingURL=discount-campaign.model.js.map